import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-mt-2 tw-flex tw-w-full tw-items-center tw-gap-2" }
const _hoisted_2 = { class: "tw-min-w-0 tw-flex-1" }
const _hoisted_3 = { class: "tw-inline-flex tw-h-10 tw-shrink-0 tw-overflow-hidden tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/70" }
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[4] || (_cache[4] = _createElementVNode("label", {
      for: "DropOffName",
      class: "uk-form-label"
    }, "Name", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_FilterableDropdown, {
          id: "DropOffName",
          modelValue: _ctx.selectedCustomer,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCustomer) = $event)),
          options: _ctx.customers,
          customLabel: (option) => (option && (option.displayName || option.name)) || '',
          class: "tw-w-full tw-min-w-0",
          onSearchChange: _ctx.onCustomerSearch
        }, null, 8, ["modelValue", "options", "customLabel", "onSearchChange"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-px-3 tw-text-slate-700 hover:tw-bg-white disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
          disabled: !_ctx.selectedCustomer,
          "uk-tooltip": "Please Select customer",
          title: "Save",
          "aria-label": "Save",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveCustomer && _ctx.saveCustomer(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "check" })
        ], 8, _hoisted_4),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tw-w-px tw-bg-slate-200/70" }, null, -1)),
        _createElementVNode("button", {
          type: "button",
          class: "tw-inline-flex tw-h-10 tw-items-center tw-justify-center tw-px-3 tw-text-slate-700 hover:tw-bg-white",
          title: "Cancel",
          "aria-label": "Cancel",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelCustomerEdit && _ctx.cancelCustomerEdit(...args)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: "xmark" })
        ])
      ])
    ])
  ]))
}